import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import { AdminsPage } from './routes/admins'
import { CalendarPage } from './routes/calendar'
import { HolidaysPage } from './routes/holidays'
import { AppShell } from './routes/layout/app-shell'
import { NotAuthorizedPage } from './routes/not-authorized/not-authorized-page'
import { PersonPage } from './routes/people'
import { SettingsPage } from './routes/settings'
import { SignInPage } from './routes/sign-in/sign-in-page'
import { TodayPage } from './routes/today/today-page'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: true,
    },
  },
})

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          <Route path="/sign-in" element={<SignInPage />} />
          <Route path="/not-authorized" element={<NotAuthorizedPage />} />
          <Route element={<AppShell />}>
            <Route path="/" element={<TodayPage />} />
            <Route path="/calendar" element={<CalendarPage />} />
            <Route path="/holidays" element={<HolidaysPage />} />
            <Route path="/people/:slackId" element={<PersonPage />} />
            <Route path="/settings" element={<SettingsPage />} />
            <Route path="/admins" element={<AdminsPage />} />
            {/* Plan 09+ routes will land here. */}
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  )
}
